import React from 'react';
import './CircularProgress.css';

const CircularProgress = ({ 
  percentage = 0, 
  size = 80, 
  strokeWidth = 6,
  color = '#4CAF50',
  backgroundColor = 'rgba(255, 255, 255, 0.2)',
  showPercentage = true,
  className = ''
}) => {
  // Ensure percentage is between 0 and 100
  const normalizedPercentage = Math.min(Math.max(percentage, 0), 100);
  
  // Calculate circle properties
  const radius = (size - strokeWidth) / 2;
  const circumference = radius * 2 * Math.PI;
  const strokeDasharray = circumference;
  const strokeDashoffset = circumference - (normalizedPercentage / 100) * circumference;
  
  // Format percentage without decimals
  const displayPercentage = Math.round(normalizedPercentage);

  return (
    <div 
      className={`circular-progress ${className}`}
      style={{ width: size, height: size }}
    >
      <svg
        width={size}
        height={size}
        className="circular-progress-svg"
      >
        {/* Background circle */}
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke={backgroundColor}
          strokeWidth={strokeWidth}
          className="circular-progress-background"
        />
        
        {/* Progress circle */}
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeDasharray={strokeDasharray}
          strokeDashoffset={strokeDashoffset}
          strokeLinecap="round"
          className="circular-progress-bar"
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
        />
      </svg>
      
      {/* Percentage text */}
      {showPercentage && (
        <div className="circular-progress-text">
          <span className="percentage-number">{displayPercentage}</span>
          <span className="percentage-symbol">%</span>
        </div>
      )}
    </div>
  );
};

export default CircularProgress;
